import i18n from '@/i18n/index';
import store from '@/store/store';
import uniqBy from 'lodash/uniqBy';
import { getAll as getAllFactures } from '@/api/facture';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { SENS_VENTE } from '@/configuration/devisConf';
import genererMail from '@/services/general/genererMail';
import getInfosClients from '@/services/general/mail/getInfosClientMail';
import getInfoContacts from '@/services/general/mail/getInfoContactsMail';
import { convertTierToMail, convertUserToMail, convertEmailToMail } from '@/services/dcf/generationMail';

export function getFilteredContacts(row, search) {
  const selectedContactIds = row.mail.to.filter(c => c.id).map(c => c.id);
  const filtered = row.contacts.map(c => {
    let contacts = c.contacts.filter(c => !selectedContactIds.includes(c.id));
    if (search) {
      contacts = contacts.filter(c => c.nomToDisplay.includes(search));
    }
    return { ...c, contacts };
  });
  return filtered.filter(c => c.contacts.length > 0);
}

async function getIntervenantsFromRelance(relance) {
  const facturesIds = [...new Set(relance.mouvementsClients.map(mvt => mvt.facture.id))];
  const factures = (await getAllFactures({
    query: {
      ids: facturesIds,
      societeId: store.getters['societe/societeActiveId'],
      sens: SENS_VENTE,
    },
  })).data.result.items;
  const intervenants = [...new Set(factures.map(f => f.intervenants).flat())];
  relance.intervenants = intervenants;
  return relance;
}

function getUsersContacts() {
  const users = store.getters['parametres/parametre'](PARAMETRES_KEYS.utilisateur).filter(u => u.actif);
  return {
    nomCommercial: i18n.t('mail.collaborateur'),
    contacts: users.filter(c => c.email).map(c => ({
      id: c.id,
      nom: c.nom,
      email: c.email,
      prenom: c.prenom,
      nomToDisplay: `${c.decorator.nomPrenom} - ${c.email}`,
    })),
  };
}

async function getContactsFromIntervenants(ralancesWithIntervenant) {
  const promises = ralancesWithIntervenant.map(async (r) => {
    let contacts = await getInfoContacts(r.intervenants, i18n.t('relance.popUpMail.contactTitle'));
    contacts = contacts.concat(getInfosClients(r.intervenants, i18n.t('relance.popUpMail.clientTitle')));
    contacts = contacts.concat(getUsersContacts());
    r.contacts = contacts
      .filter(c => c.contacts.length > 0)
      .map(c => ({ ...c, contacts: uniqBy(c.contacts, 'id') }));
    return r;
  });
  return (await Promise.all(promises)).flat();
}

function getNumberRelance(numberRelance) {
  if (!numberRelance) return '';
  if (numberRelance === 1) return i18n.t('addNewRelance.numberRelance.first');
  return numberRelance + i18n.t('addNewRelance.numberRelance.other');
}

function updateRelanceMail(r) {
  const user = store.getters['user/user'];
  const societeActive = store.getters['societe/societeActive'];
  const userAffixe1 = store.getters['permissions/userAffixe1'];
  const { emailSignataireRelance } = societeActive;

  r.mail = genererMail();
  const contactsFacture = r.contacts
    .find(c => c.nomCommercial === i18n.t('relance.popUpMail.contactTitle'))?.contacts;
  if (contactsFacture?.length === 1) r.mail.to.push(contactsFacture[0]);
  r.filteredContacts = getFilteredContacts(r);

  if (r.payeur.email) r.mail.to.push(convertTierToMail(r.payeur));
  if (user.email) {
    r.mail.from = user.email;
    if (!userAffixe1) r.mail.cci.push(convertUserToMail(user));
  }
  if (emailSignataireRelance) {
    r.mail.cci = [convertEmailToMail(emailSignataireRelance)];
    r.mail.from = emailSignataireRelance;
  }
  r.mail.corps = r.texte;
  r.mail.objet = i18n.t('relance.popUpMail.libelleObjet', {
    codeFacture: [...new Set(r.mouvementsClients.map(mvt => mvt.facture.code))].join(','),
    titreRelance: getNumberRelance(r.numRelance),
  });
  r.destinataire = null;
}

export default async function generationMailEnMasseFromRelances(relances) {
  const promises = relances.map(getIntervenantsFromRelance);
  let relancesWithData = (await Promise.all(promises)).flat();
  relancesWithData = await getContactsFromIntervenants(relancesWithData);
  relancesWithData.forEach(updateRelanceMail);
  return relancesWithData;
}
